module.exports = __webpack_public_path__ + "img/img32.e01e2f42.svg";